import mixpanel from './mixpanel'

const getHref = elem => {
  let href = elem.getAttribute(`href`)
  if (href != null) return href
  if (elem.tagName === `body`) return null
  return getHref(elem.parentElement)
}

// for external links that replace the current window (no target=_blank)
export const outbound = e => {
  e.preventDefault()
  const page = window.location.pathname
  const url = getHref(e.target)
  if (url == null) return console.log(`url was not found`)
  mixpanel.track(`outbound`, {
    page: page,
    dest: url,
  }, ()=>(window.location.href = url))
  setTimeout(()=>(window.location.href = url), 300)
}

// for external links that target _blank instead of replacing the current location
export const extlink = e => {
  const page = window.location.pathname
  const url = getHref(e.target)
  if (url == null) return console.log(`url was not found`)
  mixpanel.track(`extlink`, {
    page: page,
    dest: url,
  })
}

export default outbound



// WEBPACK FOOTER //
// ./src/analytics/outbound.js